export default function shapeToPositions(shape) {
  return shape.map((latLng) => {
    const [lat, lng] = latLng.split(',').map(Number);
    return { lat, lng };
  });
}
